import React, { useState } from "react";
import { useMixture } from '../data/mixture';
import { sortHerbsAlphabetically } from '../helpers/Helpers';
import { Button, InputGroup, Input, Textarea } from "../ui";
import AuthService from '../services/authentication';
import { useHistory } from "react-router-dom";
import MixtureImage from 'images/mixture_image.png';

function MixtureLineItem({ mixture, noteDrafts, setNoteDrafts, markupDrafts, setMarkupDrafts, handleDraftNoteChange, handleDraftMarkupChange, deleteMixture, saveOrder }) {
  let auth = AuthService.useAuth();
  let history = useHistory();
  const { mixture: mixtureData, updateProperty } = useMixture(mixture.id, auth.authHeader());

  if (!mixtureData) return null;

  const mixtureQuantityForm = () => (
    <form className="inline-flex items-center">
      <InputGroup>
        <Button
          disabled={mixtureData.quantity === 0}
          variant="secondary"
          onClick={() => {
            const newQuantity = mixtureData.quantity - 1;
            if (newQuantity === 0) {
              deleteMixture(mixtureData);
            } else {
              updateProperty('quantity', newQuantity);
            }
          }}
        >
          -
        </Button>
        <Input style={{ maxWidth: '3rem', textAlign: 'center' }} value={mixtureData.quantity || 0} readOnly />
        <Button
          variant="secondary"
          onClick={() => updateProperty('quantity', mixtureData.quantity + 1)}
        >
          +
        </Button>
      </InputGroup>
    </form>
  );

  return (
    <div className="grid grid-cols-12 gap-4 mt-4">
      <div className="col-span-2 flex justify-center">
        <img
          className="rounded border border-gray-200 bg-white p-1"
          src={MixtureImage}
          style={{ aspectRatio: '1/1', width: '100%', objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
      <div className="col-span-7">
        <div className="flex flex-wrap content-between h-full">
          <div className="w-full">
            <h4 className="text-xl font-bold tracking-tight text-gray-900 pb-2">
              {mixtureData.name ? mixtureData.name : 'New Mixture'}
            </h4>
          </div>
          <div className="w-full">
            {mixtureQuantityForm()}
            {mixtureData.herbs && sortHerbsAlphabetically(mixtureData.herbs).map(item => (
              <p className="my-2" key={item.id}>
                <span className="font-bold">{item.name}</span> {item.quantity}ml
              </p>
            ))}
            <Textarea
              name="notes"
              placeholder="Notes.."
              value={noteDrafts[mixtureData.id] !== undefined ? noteDrafts[mixtureData.id] : mixtureData.note}
              onChange={(e) => handleDraftNoteChange(mixtureData.id, e.target.value)}
              className="my-2"
            />
            <div className="my-2">
              <Button
                onClick={async () => {
                  await saveOrder();
                  history.push(`/order/mixtures/${mixtureData.id}/edit`);
                }}
                variant="secondary"
                className="me-2"
              >
                Blend Herbs
              </Button>
              <Button onClick={() => deleteMixture(mixtureData)} variant="danger">Remove</Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-3 flex content-end justify-end flex-wrap">
        <h4 className="text-2xl">${(mixtureData.patient_price * mixtureData.quantity).toFixed(2)}</h4>
      </div>
    </div>
  );
}

export default MixtureLineItem;
